/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InboundDocumentCounts } from './InboundDocumentCounts';
import {
    InboundDocumentCountsFromJSON,
    InboundDocumentCountsFromJSONTyped,
    InboundDocumentCountsToJSON,
    InboundDocumentCountsToJSONTyped,
} from './InboundDocumentCounts';

/**
 * 
 * @export
 * @interface GetInboundDocumentCounts200Response
 */
export interface GetInboundDocumentCounts200Response {
    /**
     * 
     */
    data?: InboundDocumentCounts;
}

/**
 * Check if a given object implements the GetInboundDocumentCounts200Response interface.
 */
export function instanceOfGetInboundDocumentCounts200Response(value: object): value is GetInboundDocumentCounts200Response {
    return true;
}

export function GetInboundDocumentCounts200ResponseFromJSON(json: any): GetInboundDocumentCounts200Response {
    return GetInboundDocumentCounts200ResponseFromJSONTyped(json, false);
}

export function GetInboundDocumentCounts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInboundDocumentCounts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : InboundDocumentCountsFromJSON(json['data']),
    };
}

export function GetInboundDocumentCounts200ResponseToJSON(json: any): GetInboundDocumentCounts200Response {
    return GetInboundDocumentCounts200ResponseToJSONTyped(json, false);
}

export function GetInboundDocumentCounts200ResponseToJSONTyped(value?: GetInboundDocumentCounts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': InboundDocumentCountsToJSON(value['data']),
    };
}

